import React, { useState } from 'react';
import { Typography, Container, Box, Dialog, DialogTitle, DialogContent } from '@mui/material';
import { useTheme, useMediaQuery } from '@mui/material';

const Question = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [open, setOpen] = useState(false);
 
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Container
      className="mb-5 mt-5"
      style={{
        fontFamily: 'Roboto, sans-serif',
        padding: isMobile ? '0 16px' : '0 32px', // Adjust padding for mobile
      }}
    >
      <Box mb={3} mt={4}>
        <Typography 

          style={{
            fontSize: isMobile ? '18px' : '22px',
            fontWeight: 'bold',
            fontFamily: 'Roboto, sans-serif',
            color: 'black',
          }}
        >
          Contact Us
        </Typography>
      </Box>
      
      <Box mb={2}>
        <Typography
          style={{ fontSize: isMobile ? '15px' : '17px', color: 'black', }}
         
        >
          Call Center: <a href="tel:+04224370437" style={{ textDecoration: 'none' }}>0422 437 0437</a>
        </Typography>
      </Box>
      
      <Box mb={2}>
        <Typography
          style={{
            fontSize: isMobile ? '15px' : '17px',
            cursor: 'pointer',
            fontFamily: 'Roboto, sans-serif',
            color: 'black',
          }}
         
         
        >
          Store: <div  onClick={handleClickOpen}>
          Click here to view the location
            </div>
        </Typography>
        {/* <Typography
          style={{
            fontSize: isMobile ? '12px' : '12px',
            color: 'gray',
            marginTop: '4px',
          }}
        >
          (Click here to view the location on the map)
        </Typography> */}
      </Box>
      
      <Box mb={2}>
        <Typography style={{ fontSize: isMobile ? '15px' : '17px',  fontFamily: 'Roboto, sans-serif',color: 'black', }}>
          Email: <a style={{ fontSize: '18px' }} href='mailto:planmitrip@gmail.com'>planmitrip@gmail.com</a>
        </Typography>
      </Box>

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
        <DialogTitle>Store Location</DialogTitle>
        <DialogContent>
          <Box mt={2} mb={2}>
            <iframe
              title="Store Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15665.120055798452!2d76.95710772826797!3d11.01760518869438!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba85855910aed83%3A0x80875de5cd370a9d!2sGandhipuram%2C%20Tamil%20Nadu%20641012!5e0!3m2!1sen!2sin!4v1722925284531!5m2!1sen!2sin" 
              // width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
              width="100%"
              frameBorder="0"
              style={{ border: 0 }}
              allowFullScreen=""
              aria-hidden="false"
              tabIndex="0"
              height={isMobile ? '150' : '350'}
            ></iframe>
          </Box>
        </DialogContent>
      </Dialog>
    </Container>
  );
}

export default Question;
